import { render, staticRenderFns } from "./FixOrderSelectItemCard.vue?vue&type=template&id=dd6ffbbe&scoped=true&"
import script from "./FixOrderSelectItemCard.vue?vue&type=script&lang=ts&"
export * from "./FixOrderSelectItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./FixOrderSelectItemCard.vue?vue&type=style&index=0&id=dd6ffbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6ffbbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRow,VTextField})
